export const MuiCircularProgress = {
  styleOverrides: {
    root: {
      color: '#000',
    },
  },
}
